angular.module('app.api').factory('SignUpApi', [
  'api',
  function SignUpApi(api) {
    const signUpApi = {
      signUp: async payload => {
        const result = await api.post(
          'auth/signup',
          payload,
          {
            withCredentials: true,
          },
          undefined,
          true
        )
        console.debug('SignUpApi result', result)
        return result
      },
    }
    return signUpApi
  },
])



// WEBPACK FOOTER //
// ./scripts/sign-up/sign-up.api.js